// extracted by mini-css-extract-plugin
export var button = "Code-module--button--e3ab8";
export var cdsAssistiveText = "Code-module--cds--assistive-text--37c66";
export var cdsVisuallyHidden = "Code-module--cds--visually-hidden--c4b81";
export var container = "Code-module--container--d1c76";
export var copyButton = "Code-module--copy-button--e713d";
export var dark = "Code-module--dark--add48";
export var hideFeedback = "Code-module--hide-feedback--e9ff4";
export var highlight = "Code-module--highlight--476ef";
export var path = "Code-module--path--b80e9";
export var pathRow = "Code-module--path-row--851b9";
export var row = "Code-module--row--2227e";
export var showFeedback = "Code-module--show-feedback--c40b7";
export var showMoreButton = "Code-module--show-more-button--63011";
export var sideBarMinHeight = "Code-module--sideBarMinHeight--1a7ad";
export var sidebar = "Code-module--sidebar--7dce0";
export var skeleton = "Code-module--skeleton--b784a";